import { render, staticRenderFns } from "./BaseSystemBar.vue?vue&type=template&id=0f64f5b5"
import script from "./BaseSystemBar.vue?vue&type=script&lang=js"
export * from "./BaseSystemBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports